export const timer = async(ms: number) => {
    return new Promise(res => setTimeout(res, ms));
}